import { useEffect } from 'react'
import { pipe } from 'lodash/fp'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Flex, useThemeStore, subscribeTheme } from '@stoplight/mosaic'
import {
  withMosaicProvider,
  withPersistenceBoundary,
  withStyles,
} from '@stoplight/elements-core'
import { QueryClient, QueryClientProvider } from 'react-query'

import { articles } from './constants'
import TopNav from './components/TopNav'
import Spec from './components/Spec'
import Articles from './components/Articles'
import Page from './components/Page'
import NotFound from './components/NotFound'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  const { mode, setMode } = useThemeStore()

  useEffect(() => {
    setMode(mode)

    // Only want to run this effect on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    subscribeTheme({ mode: mode === 'dark' ? 'dark' : 'light' })
  }, [mode])

  return (
    <QueryClientProvider client={queryClient}>
      <TopNav />
      <Flex flexGrow bg="canvas" pt={16} w="full" h="screen" mx="auto">
        <Switch>
          <Redirect exact from="/" to="/authorization" />
          <Route path="/authorization">
            <Articles items={articles['authorization']} />
          </Route>
          <Route path="/core-resources">
            <Spec
              apiDescriptionUrl={`${process.env.PUBLIC_URL}/NinjaRMM-API-v2.yaml`}
              basePath="/core-resources"
            />
          </Route>
          <Route path="/404">
            <NotFound />
          </Route>
          <Route path="*">
            <Page />
          </Route>
        </Switch>
      </Flex>
    </QueryClientProvider>
  )
}

export default pipe(
  withStyles,
  withPersistenceBoundary,
  withMosaicProvider
)(App)
